import * as Fn from "../../../data/function";
export const getter = (view) => ({
    view,
    foldr: (fold, empty, s) => fold(view(s), empty),
});
export const of = () => getter((a) => a);
export const view = (g, s) => g.view(s);
export const compose = (g1, g2) => getter(Fn.compose(g1.view, g2.view));

